import * as React from "react";
import {Purchase,} from "@models/purchase";
import {Table} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {PaymentGatewayOptions} from "@models/paymentGateway";
import {getFormattedPrice} from "@utils";
import {PurchaseStatusOptions} from "../../../../../models/purchase";
import __i18n from "../../../../../intl/__i18n";
import {NavLink, Link} from "react-router-dom";

type Props = {
  data: Purchase[];
  loading: boolean;
  currentPage: number;
};

const UserPurchasesTable: React.FC<Props> = props => {
  const {data, loading, currentPage} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      align:"right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: __i18n("Product Name") ,
      dataIndex: "video_content_title",
      key: "video_content_title",
      align:"right",
      render: (video_content_title, record) => <Link to={`/video-contents/${record.product_reference_id}/report`}>{video_content_title}</Link>
    },
    {
      title: <FormattedMessage id="app.price" defaultMessage={`Price`}/>,
      dataIndex: "price",
      key: "price",
      render: (price, record) => getFormattedPrice(price)
    },
    {
      title: <FormattedMessage id="app.effective_price" defaultMessage={`Effective Price`}/>,
      dataIndex: "effective_price",
      key: "effective_price",
      align:"center",
      render: (effective_price, record) => getFormattedPrice(effective_price)
    },
    {
      title: __i18n("Package Purchase Template"),
      dataIndex: "package_purchase_template",
      key: "package_purchase_template",
      align:"center",
      render: (package_purchase_template, record) => package_purchase_template && package_purchase_template.title
    },
    {
      title: <FormattedMessage id="app.payment_gateway" defaultMessage={`payment_gateway`}/>,
      dataIndex: "payment_gateway",
      key: "payment_gateway",
      align:"right",
      render: (payment_gateway, record) => PaymentGatewayOptions.find( item => item.value === payment_gateway )["label"]
    },
    {
      title: <FormattedMessage id="app.status" defaultMessage={`status`}/>,
      dataIndex: "status",
      key: "status",
      align:"left",
      render: (status, record) => PurchaseStatusOptions.find( item => item.value === status )["label"]
    },
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default UserPurchasesTable;
